export enum QueryParam {
  Affiliate = 'affiliate',
  Url = 'url',
  Token = 'token',
  CartId = 'cart',
  EventId = 'event',
  TimeslotId = 'timeslot',
  Locale = 'locale',
  AppVersion = 'appversion',
}
